import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Vaata ka

  <span style="color:#85c1dc;">**FI:**</span>
  

  <span style="color:#85c1dc;">**RU:**</span>
  
*/
/* @__NO_SIDE_EFFECTS__ */
const m1963 = msg(
  mf`Vaata ka`,
  mf``,
  mf``,
)

export { m1963 as 'w.product.replacement-product.more' }